import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EmailEvent } from 'src/app/shared/models/email-event';

@Component({
  standalone: false,
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
})
export class EventListComponent {
  @Input() allEvents: EmailEvent[];

  constructor(private router: Router) {}

  handleClick(eventName: string) {
    this.router.navigateByUrl(`notification-engine/admin/${eventName}`);
  }
}

